function getError(action, method, xhr) {
  let msg
  if (xhr.response) {
    msg = `${xhr.response.error || xhr.response}`
  } else if (xhr.responseText) {
    msg = xhr.responseText
  } else {
    msg = `fail to ${method} ${action} ${xhr.status}`
  }
  const err = new Error(msg)
  err.status = xhr.status
  err.method = method
  err.url = action
  return err
}

function getBody(xhr) {
  const text = xhr.responseText || xhr.response
  if (!text) {
    return text
  }
  try {
    return JSON.parse(text)
  } catch (e) {
    return text
  }
}

export default function upload(options) {
  if (typeof XMLHttpRequest === 'undefined') {
    return
  }
  const {
    data = {},
    action,
    // filename,
    // eslint-disable-next-line no-unused-vars
    // file,
    headers = {},
    withCredentials = false,
    onProgress = () => {},
    onSuccess = () => {},
    onError = () => {}
  } = options
  const xhr = new XMLHttpRequest()
  xhr.stop = () => {
    xhr.abort()
  }
  if (xhr.upload) {
    xhr.upload.onprogress = evt => {
      if (evt.total > 0) {
        evt.percent = (evt.loaded / evt.total) * 100
      }
      onProgress(evt)
    }
  }

  const formData = new FormData()
  if (data) {
    Object.keys(data).forEach(k => {
      formData.append(k, data[k])
    })
  }
  // 去除ie浏览器上传的文件名带的路径
  let fileName = options.file.name
  fileName = fileName.substring(fileName.lastIndexOf('/') + 1)
  fileName = fileName.substring(fileName.lastIndexOf('\\') + 1)

  // let newFile = new File([options.file], fileName, { type: options.file.type })

  // formData.append(filename, newFile, newFile.name)

  formData.append('file', options.file, fileName)
  xhr.onerror = onError
  xhr.onload = () => {
    if (xhr.status < 200 || xhr.status >= 300) {
      return onError(getError(action, 'post', xhr))
    }
    onSuccess(getBody(xhr))
  }
  xhr.open('post', action, true)
  if (withCredentials && 'withCredentials' in xhr) {
    xhr.withCredentials = true
  }
  for (let k in headers) {
    if (headers.hasOwnProperty(k) && headers[k] !== null) {
      xhr.setRequestHeader(k, headers[k])
    }
  }
  xhr.send(formData)
  return xhr
}



// WEBPACK FOOTER //
// ./src/utils/ajax.js